import designerReport from '@/reporter/instance/designerReport';
export const AI_MODULE_MAP = {
    LESSCODE: 'wuji:lesscode',
    LESSCODE_MODULE: 'wuji:lesscode:module',
    UICORE_CODE: 'wuji:uicoreai',
    ROUTE_GUARD: 'wuji:route:guard',
    DATASOURCE_METHOD: 'wuji:datasource:method',
    DATASOURCE_PLUGIN: 'wuji:datasource:plugin',
    DATASOURCE_NODEJS: 'wuji:datasource:nodejs',
    DATASOURCE_MCP: 'wuji:datasource:mcp',
    PARSE_API_DOC: 'wuji:parse:apidoc',
    CHAT: 'chat',
    BI: 'wuji:bi',
    LAYOUT: 'wuji:layout',
    ATOM_MANAGER: 'AtomManager',
    FLOW_ENGINE: 'wuji:flowEngine',
    RUNTIME_AI_ATOM: 'wuji:runtime:ai:atom',
    RUNTIME_AI_SDK: 'wuji:runtime:ai:sdk',
    AIPAGE_GENERATOR: 'wuji:aipage:generator',
};
// i18n ignore next line
const eid = 'ai消息发送(全)';
const mod = 'ai';
const traceIdWithoutModule = Date.now().toString(36);
export const getTraceIdWithoutModule = () => traceIdWithoutModule;
const getTraceId = (id) => `${id} || ${traceIdWithoutModule}`;
export const getTraceIdHeaders = (id) => ({
    'x-wuji-trace-id': getTraceId(id),
});
export const reportDesignerAISendMessage = ({ d1, d2 }) => {
    designerReport.report('click', { eid, mod, d1, d2 });
};
